export var aiHubTelemetryConfig = {
    appName: 'AIHub',
    diagnosticTelemetryNamespace: 'Office.AIHub.Diagnostic',
    diagnosticOTelAriaTenant: '1db0efd9ca9a4b6291b3dde4ebaed6de-14fd67ab-f1c3-4e6a-a9e9-41cc6df2a416-7524',
    oTelAriaTenant: '86e373bba78849b9a171f1691f60be36-8b939b94-65a5-48dc-bb15-7db2cdb0650f-7210',
    telemetryNamespace: 'Office.AIHub.Web.OfficeStartInfra',
};
//# sourceMappingURL=aiHubTelemetryConfig.js.map